module.exports = __webpack_public_path__ + "static/media/ciel-bordeaux.1f61ba82.png";